import CTALink from "@/components/CTA/ctaLink";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";

export default function PromoBannerCompact({
  className,
  cta,
  ctaElement,
  description,
  discount,
  discountCode,
  endDate,
  endDatePrefix = "Offer ends",
  learnMoreLink,
  title,
  useDefaultDiscountText = true,
  tooltip,
}: BasePromoBannerProps) {
  return (
    <div
      className={`flex flex-col md:flex-row justify-between items-center gap-8 p-8 bg-primary rounded-xl ${className || ""}`}
    >
      <div>
        <h2 className="text-primary-foreground mt-0 mb-4">{title}</h2>
        <p className="text-primary-foreground elm-p3 mb-0">
          {typeof description === "string"
            ? boldTextWithAsterisk(description)
            : description}{" "}
          {useDefaultDiscountText && !!discount && !!discountCode && (
            <>
              Get <strong>up to {discount} off</strong> with code{" "}
              <strong>{discountCode}</strong>.
            </>
          )}{" "}
          {endDatePrefix} {endDate}.{" "}
          <span className="inline-block align-middle">
            <PromoBannerTooltip
              discountCode={discountCode}
              endDate={endDate}
              learnMoreLink={learnMoreLink}
              htmlContent={tooltip?.infoText ?? ""}
              size={16}
            />
          </span>
        </p>
      </div>
      {ctaElement}
      {cta && !ctaElement && (
        <CTALink
          type="brand"
          size="xl"
          className="w-full md:w-auto [&_span]:whitespace-nowrap"
          label={cta.label}
          url={cta.url}
          location={cta.location}
          html_id={cta.html_id}
        />
      )}
    </div>
  );
}
